"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Undo: function() {
        return Undo;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Undo = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M12.207 2.29303C12.3945 2.48056 12.4998 2.73487 12.4998 3.00003C12.4998 3.26519 12.3945 3.5195 12.207 3.70703L10.914 5.00003H12.5C17.152 5.00003 21 8.84803 21 13.5C21 18.152 17.152 22 12.5 22C7.848 22 4 18.152 4 13.5C4 13.2348 4.10536 12.9805 4.29289 12.7929C4.48043 12.6054 4.73478 12.5 5 12.5C5.26522 12.5 5.51957 12.6054 5.70711 12.7929C5.89464 12.9805 6 13.2348 6 13.5C6 17.048 8.952 20 12.5 20C16.048 20 19 17.048 19 13.5C19 9.95203 16.048 7.00003 12.5 7.00003H10.914L12.207 8.29303C12.3892 8.48163 12.49 8.73423 12.4877 8.99643C12.4854 9.25863 12.3802 9.50944 12.1948 9.69485C12.0094 9.88026 11.7586 9.98543 11.4964 9.9877C11.2342 9.98998 10.9816 9.88919 10.793 9.70703L7.793 6.70703C7.60553 6.5195 7.50021 6.26519 7.50021 6.00003C7.50021 5.73487 7.60553 5.48056 7.793 5.29303L10.793 2.29303C10.9805 2.10556 11.2348 2.00024 11.5 2.00024C11.7652 2.00024 12.0195 2.10556 12.207 2.29303Z",
        fill: "currentColor"
    })
}), "Undo");
const _default = Undo;
